export const transformDistrictLevelToId = (districtLevel) => {
  const level = String(districtLevel)
  switch (level) {
    case '2':
      return 'provinceId'
    case '3':
      return 'cityId'
    case '4':
      return 'countyId'
    case '5':
      return 'streetId'
    default:
      return level
  }
}

export const addError = (el, data) => {
  const error = el.$el
  if (error) {
    const hasError = error.querySelectorAll('.el-form-item__error')
    if (hasError.length) {
      return
    }
    const errorNode = createError(data)
    error.classList.add('kye-address-error')
    error.appendChild(errorNode)
  }
}

export const createError = (data) => {
  const errorDiv = document.createElement('div')
  errorDiv.className = 'el-form-item__error el-form-item__error-pop'
  const textNode = document.createTextNode(data.text)
  const arrowNode = document.createElement('span')
  arrowNode.className = 'el-form-item__error-pop__arrow-top'
  errorDiv.appendChild(textNode)
  errorDiv.appendChild(arrowNode)
  return errorDiv
}

export const clearError = (el) => {
  const error = el.$el
  if (error) {
    error.classList.remove('kye-address-error')
    const errorNode = error.querySelectorAll('.el-form-item__error')
    Array.from(errorNode).forEach(node => {
      error.removeChild(node)
    })
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-address/utils.js